module.exports = __webpack_public_path__ + "img/02e92f3.jpg";